export const DefaultCameraSource = ["Front", "Back"];

export const StreamingState = {
    Okay: "STREAM_OKAY",
    Slow: "STREAM_SLOW",
    None: "STREAM_NONE",
    Reconnecting: "STREAM_RECONNECTING",
};
